
const imageUrl = (title) => {
  return `/imgs/solution/finance/${title}.png`;
};

const data = {
  banner: {
    title: '供应链金融系统综合解决方案',
    description: '供应链金融系统可为商贸和供应链企业提供代理采购、仓单质押融资、仓单抵押融资、应收账款质押、应收账款转让、贸易真实性、授信融资信息、交易信息、以及物流信息监控等业务。',
    bg: imageUrl('banner')
  },
  method: [
    {
      img: imageUrl('method1'),
      title: '国内外代理采购'
    },
    {
      img: imageUrl('method2'),
      title: '仓单质押融资'
    },
    {
      img: imageUrl('method3'),
      title: '仓单抵押融资'
    },
    {
      img: imageUrl('method4'),
      title: '应收账款质押'
    },
    {
      img: imageUrl('method5'),
      title: '应收账款转让'
    },
  ],
  advantage: [
    {
      img: imageUrl('advantage1'),
      title: '产品优势',
      description: '通过集合货权、贸易真实性、动态交易大数据、资金流向的实时体系化监管，实现完整的物流、商流、数据流及资金流“四流合一”的风控闭环。'
    },
    {
      img: imageUrl('advantage2'),
      title: '高效安全',
      description: '为企业提供：对接企业内部ERP、第三方信息接口等数据，助力客户高效、安全稳定的发展。'
    },
    {
      img: imageUrl('advantage3'),
      title: '解决资金周转',
      description: '为企业在采购、物流、销售、库存等全方面解决贸易环节资金周转问题。'
    },
    {
      img: imageUrl('advantage4'),
      title: '降低成本',
      description: '优化匹配资金方和企业金融需求，保障资金安全，提高资金规模化利用效率，帮助供应链上下游企业扩宽融资渠道，降低企业融资成本。'
    },
    {
      img: imageUrl('advantage5'),
      title: '尾货处理',
      description: '尾货处理平台，帮企业减少损失，快速回笼资金。'
    },
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Solution/config/finance.js